<template>
    <div class="main-container">
        <div v-if="loader.data" class="loading-container">
            <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
        </div>
        <div v-else-if="!loader.data && filterReports.length > 0" class="report-container">
            <report-card
                v-for="report in filterReports"
                :key="report.fileSql"
                :data="report"
                :teams="data.teams"
                :products="data.products"
            />
        </div>
        <div v-else>Não há relatórios para exibir...</div>
        <report-download-modal />
    </div>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'

	import reportCard from '../components/report-card'
	import reportDownloadModal from '../components/report-download-modal'

	import { offline, product } from '@/services/axios'

	const defaultLoader = () => ({
		data: true,
	})

	export default {
		components: { uiLoadIndicator, reportCard, reportDownloadModal },

		data() {
			return {
				data: {
					reports: [],
					teams: [],
					products: [],
				},
				loader: { ...defaultLoader() },
			}
		},

		computed: {
			// Returns only the reports of the selected category
			filterReports() {
				if (this.$route.name == 'report.basics.all') return this.data.reports

				return this.data.reports.filter(
					(report) => report.title == this.$route.params.title.toUpperCase(),
				)
			},
		},

		async created() {
			// Get the athena reports list, "side-menu" component has already made the request and he sent it here
			this.$root.$on('athena-reports', (response) => {
				this.data.reports = response.data
			})

			await this.getProducts()
			await this.getTeams()

			this.loader.data = false
		},

		beforeDestroy() {
			this.$root.$off('athena-reports')
		},

		methods: {
			// Request the empreendimentos list registered in the system
			async getProducts() {
				try {
					const response = await product.getAll('')
					this.data.products = response.data
				} catch {}
			},

			// Request the grupos (teams) list registered in the system
			async getTeams() {
				try {
					const response = await offline.getTeams()
					this.data.teams = response.data
				} catch {}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
